<template>
  <ContentSection>
    <Container indent="wide">
      <div class="justify-between gap-10 lg:flex">
        <h2
          v-if="data.heading"
          class="default-component-title"
          :class="data.link ? 'mb-3 xl:mb-8' : 'mb-8 sm:mb-10'"
          v-html="$replaceHtmlTags(data.heading)"
        />

        <AppLink
          v-if="data.link && data.link_text"
          class="mb-7 sm:text-md xl:mb-0"
          :to="data.link"
          :target="data.target?.value"
        >
          {{ data.link_text }}
        </AppLink>
      </div>
      <AnimatedContainer>
        <ul class="grid grid-cols-1 gap-4 sm:gap-8 xl:grid-cols-2">
          <li v-for="event in events" :key="event.id" class="fade-in flex">
            <EventCard :data="event" />
          </li>
        </ul>
      </AnimatedContainer>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, default: () => ({}) },
})

const pageId = inject('pageId', null)

const { locale } = useI18n()
const fetchedEvents = ref(null)

// FUNCTIONS
async function fetchEvents() {
  let payload = await useAsyncGql({
    operation: 'Events',
    variables: {
      sort: 'date asc',
      limit: 4,
      filter: {
        site: locale.value,
        id: { not: pageId },
        section: switchContainsOrIn(props.data?.restricted_sections),
      },
    },
  })

  payload = payload.data.value?.entries

  if (!payload) {
    console.error('EventsTeaser: Events could not be fetched')
    return
  }

  fetchedEvents.value = payload.data
}

// COMPUTED
const events = computed(() => {
  if (props.data.selection.value === 'automatic') {
    return fetchedEvents.value || []
  }

  return props.data.events || []
})

// WATCHERS
watch(
  () => props.data,
  async (newValue) => {
    if (newValue.selection?.value === 'automatic') {
      await fetchEvents()
    }
  },
  { deep: true }
)

// INITIAL
if (props.data.selection.value === 'automatic') {
  await fetchEvents()
}
</script>
